import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/adminUsers", {
    params,
  });

const get = (id) => authApi.get(`/adminUsers/${id}`);

const create = ({ loginEmail, lastName, firstName, password, mobile, department, position, status }) =>
  authApi.post(`/adminUsers`, {
    loginEmail,
    lastName,
    firstName,
    password,
    mobile,
    department,
    position,
    status,
  });

const update = ({ id, loginEmail, lastName, firstName, password, mobile, department, position, status, language }) =>
  authApi.put(`/adminUsers`, {
    id,
    loginEmail,
    lastName,
    firstName,
    password,
    mobile,
    department,
    position,
    status,
    language,
  });

export { getAll, get, create, update };
